/**
 * We take the approach of organizing each “cast member” in a scene within its own file.
 * This is a choice and isn’t required, but it does isolate internal changes/enhancements
 * to these specific “characters.”
 */
import {Group, CircleBufferGeometry, MeshToonMaterial, Shape, ExtrudeBufferGeometry, MeshBasicMaterial, MeshPhongMaterial, FlatShading, Mesh, SphereGeometry, DoubleSide} from 'three'
/**
 * The use of a JavaScript “class” is also a design choice.
 */

class Fish {
  constructor(color){
    this.group = new Group()
    this.materials = []

    this.finGeometry = new CircleBufferGeometry(8.9, 8, 0, Math.PI*.14)
    this.finsMaterial = new MeshBasicMaterial({color: 0xfff355, shading: FlatShading})
    this.finsMaterial.side = DoubleSide
    this.materials.push(this.finsMaterial)
    this.leftFin = new Mesh(this.finGeometry, this.finsMaterial)
    this.leftFin.position.y = 1
    this.leftFin.position.x = .6
    this.leftFin.scale.set(-.069 , -.12, -.1)
    this.leftFin.rotation.y = Math.PI/2
    this.leftFin.position.z = 0
    this.group.add(this.leftFin)

    this.rightFin = new Mesh(this.finGeometry, this.finsMaterial)
    this.rightFin.position.y = 1
    this.rightFin.position.x = .6
    this.rightFin.scale.set(.069 , -.12, -.1)
    this.rightFin.rotation.y = Math.PI/2
    this.rightFin.position.z = .092
    this.group.add(this.rightFin)

    this.tailGeometry = new CircleBufferGeometry(10, 5, 0, Math.PI*.5)
    this.tailFin = new Mesh(this.tailGeometry, this.finsMaterial)
    this.tailFin.position.y = 1.86
    this.tailFin.position.x = .282
    this.tailFin.scale.set(.06 , .06, .7)
    this.tailFin.rotation.z = Math.PI/4
    this.tailFin.position.z = .092
    this.group.add(this.tailFin)

    const shape = new Shape();
    const x = 0;
    const y = 0;
    shape.moveTo( x + 5, y + 5 );
    shape.bezierCurveTo( x + 5, y + 5, x + 4, y, x, y );
    shape.bezierCurveTo( x - 9, y, x - 9, y + 12,x - 9, y + 12 );
    shape.bezierCurveTo( x - 6, y + 11, x - 3, y + 15.4, x + 5, y + 19 );
    shape.bezierCurveTo( x + 12, y + 15.4, x + 16, y + 11, x + 16, y + 7 );
    shape.bezierCurveTo( x + 16, y + 7, x + 16, y, x + 10, y );
    shape.bezierCurveTo( x + 10, y, x + 5, y + 8, x + 8, y + 8 );
    
    const extrudeSettings = {
      steps: 2,
      depth: 2,
      bevelEnabled: true,
      bevelThickness: 1,
      bevelSize: 1,
      bevelSegments: 2,
      };
  
    this.geometry = new ExtrudeBufferGeometry(shape, extrudeSettings);
    this.bodyMaterial = new MeshPhongMaterial({color: 0x0000ff})
    this.materials.push(this.bodyMaterial)
    this.body = new Mesh(this.geometry, this.bodyMaterial);
    this.body.scale.set(.06,.1,.06)
    this.group.add(this.body);

    this.eyeGeometry = new SphereGeometry(0.15, 10, 10)
    this.eyeMaterial = new MeshToonMaterial({ color: 0xffffff})
    this.materials.push(this.eyeMaterial)
    this.lefteye = new Mesh(this.eyeGeometry, this.eyeMaterial)   
    this.lefteye.rotation.x = Math.PI / 2;
    this.lefteye.position.y = .4
    this.lefteye.position.x = -.1
    this.lefteye.position.z = .14
    this.group.add(this.lefteye)
         
    this.irisGeometry = new SphereGeometry(0.12, 10, 10)
    this.irisMaterial = new MeshPhongMaterial({ color: 0xf822fc, emissive: 0xe56666, specular: 0x111111})
    this.materials.push(this.irisMaterial)
    this.leftiris = new Mesh(this.irisGeometry, this.irisMaterial)   
    this.leftiris.rotation.x = Math.PI / 2;
    this.leftiris.position.y = .393
    this.leftiris.position.x = -.1
    this.leftiris.position.z = .19
    this.group.add(this.leftiris)

    this.pupilGeometry = new SphereGeometry(0.092, 10, 10)
    this.pupilMaterial = new MeshToonMaterial({ color: 0x0})
    this.materials.push(this.pupilMaterial)
    this.leftPupil = new Mesh(this.pupilGeometry, this.pupilMaterial)   
    this.leftPupil.rotation.x = Math.PI / 2;
    this.leftPupil.position.y = .389
    this.leftPupil.position.x = -.1
    this.leftPupil.position.z = .23
    this.group.add(this.leftPupil)

    this.eyeGlareGeometry = new SphereGeometry(0.0211, 6, 6)
    this.eyeGlareMaterial = new MeshToonMaterial({ color: 0xffffff})
    this.materials.push(this.eyeGlareMaterial)
    this.leftEyeGlare = new Mesh(this.eyeGlareGeometry, this.eyeGlareMaterial)   
    this.leftEyeGlare.rotation.x = Math.PI / 2;
    this.leftEyeGlare.position.y = .389
    this.leftEyeGlare.position.x = -.1
    this.leftEyeGlare.position.z = .311
    this.group.add(this.leftEyeGlare)
    
    this.material = new MeshToonMaterial({ color: 0xffffff})
    this.righteye = new Mesh(this.eyeGeometry, this.eyeMaterial)   
    this.righteye.rotation.x = Math.PI / 2;
    this.righteye.position.y = .4
    this.righteye.position.x = -.09
    this.righteye.position.z = -.04
    this.group.add(this.righteye)

    this.rightiris = new Mesh(this.irisGeometry, this.irisMaterial)   
    this.rightiris.rotation.x = Math.PI / 2;
    this.rightiris.position.y = .393
    this.rightiris.position.x = -.09
    this.rightiris.position.z = -.09
    this.group.add(this.rightiris)

    this.rightpupil = new Mesh(this.pupilGeometry, this.pupilMaterial)   
    this.rightpupil.rotation.x = Math.PI / 2;
    this.rightpupil.position.y = .389
    this.rightpupil.position.x = -.09
    this.rightpupil.position.z = -.13
    this.group.add(this.rightpupil)

    this.rightEyeGlare = new Mesh(this.eyeGlareGeometry, this.eyeGlareMaterial)   
    this.rightEyeGlare.rotation.x = Math.PI / 2;
    this.rightEyeGlare.position.y = .389
    this.rightEyeGlare.position.x = -.1
    this.rightEyeGlare.position.z = -.22
    this.group.add(this.rightEyeGlare)

    this.group.position.set(1,1,1)
    this.group.rotation.z = -1*Math.PI/2 +.2
    this.group.rotation.y = 2*Math.PI/3
    this.group.scale.set = (1.4, 1.4, 1.4)
  }
}

export default Fish;

   